import { GridRenderer } from "../rendering/GridRenderer.ts";
import { EntityRenderer } from "../rendering/EntityRenderer.ts";
import { FirewallRenderer } from "../rendering/FirewallRenderer.ts";
import { HazardPoolRenderer } from "../rendering/HazardPoolRenderer.ts";
import { ParticleSystem } from "../rendering/ParticleSystem.ts";
import { ScreenEffects } from "../rendering/ScreenEffects.ts";
import { WebGL2Effects } from "../rendering/WebGL2Effects.ts";
import { CanvasScaler } from "../rendering/CanvasScaler.ts";
import { FloatingDamageNumbers } from "../rendering/FloatingDamageNumbers.ts";
import { CELL_SIZE } from "../core/config.ts";
import type { Grid } from "../core/Grid.ts";

export interface RenderersResult {
  canvas: HTMLCanvasElement;
  ctx2d: CanvasRenderingContext2D;
  webglEffects: WebGL2Effects;
  gridRenderer: GridRenderer;
  entityRenderer: EntityRenderer;
  firewallRenderer: FirewallRenderer;
  hazardPoolRenderer: HazardPoolRenderer;
  particleSystem: ParticleSystem;
  screenEffects: ScreenEffects;
  floatingDmg: FloatingDamageNumbers;
  canvasScaler: CanvasScaler;
}

export function createRenderers(grid: Grid): RenderersResult {
  const canvas = document.getElementById("game-canvas") as HTMLCanvasElement;
  const webglCanvas = document.getElementById(
    "webgl-canvas",
  ) as HTMLCanvasElement;
  const wrapper = document.getElementById("game-wrapper") as HTMLElement;
  const canvasScaler = new CanvasScaler();
  canvasScaler.attach(wrapper, canvas);

  const ctx2d = canvas.getContext("2d")!;
  ctx2d.setTransform(canvasScaler.dpr, 0, 0, canvasScaler.dpr, 0, 0);

  const webglEffects = new WebGL2Effects(webglCanvas);
  const gridRenderer = new GridRenderer(grid, ctx2d, CELL_SIZE);
  const entityRenderer = new EntityRenderer(ctx2d, CELL_SIZE);
  const firewallRenderer = new FirewallRenderer(ctx2d, CELL_SIZE);
  const hazardPoolRenderer = new HazardPoolRenderer(ctx2d, CELL_SIZE);
  const particleSystem = new ParticleSystem(ctx2d);
  const screenEffects = new ScreenEffects();
  const floatingDmg = new FloatingDamageNumbers();

  return {
    canvas,
    ctx2d,
    webglEffects,
    gridRenderer,
    entityRenderer,
    firewallRenderer,
    hazardPoolRenderer,
    particleSystem,
    screenEffects,
    floatingDmg,
    canvasScaler,
  };
}
